import { render, staticRenderFns } from "./LiquidacionDetalladoTab.vue?vue&type=template&id=5c5f7aa1&"
import script from "./LiquidacionDetalladoTab.vue?vue&type=script&lang=js&"
export * from "./LiquidacionDetalladoTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports